import queryString from 'query-string';
import _ from 'lodash';
import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, storageKeys} from '../../util/uiconstants';
import {groupInstructinALRAPackageUrl} from '../apiUrls';
import {loadStorage} from '../../components/Common/localStorage';

export const getAllRelatedDocuments = (
	engagementId,
	targetEngagementId,
	documentId,
	entityUID,
	bodyId,
	filteredEntityType,
	categoryName,
	includeApprovals,
	pageSize,
	currentPage,
	searchString,
	includeReviewNotes = false,
	groupAuditCall = null,
	includeRelatedTasks = false,
	trackWithArea,
	includeRelatedEntities = false
) => {
	const queryStringParameters = {
		filteredEntityType: filteredEntityType,
		filteredEntityIdGuid: documentId,
		filteredEntityIdInt: entityUID,
		documentCategoryName: categoryName,
		includeApprovals,
		page: currentPage,
		pageSize,
		includeReviewNotes: includeReviewNotes,
		includeRelatedTasks: includeRelatedTasks,
		includeRelatedEntities: includeRelatedEntities
	};

	if (targetEngagementId && targetEngagementId > 0) {
		queryStringParameters.targetEngagementId = targetEngagementId;
	}

	if (searchString && searchString.length > 0) {
		queryStringParameters.searchString = searchString;
	}

	const url = getDocumentsUrl(engagementId, queryStringParameters);

	const entityUId = groupAuditCall === null ? bodyId : groupAuditCall;

	return {
		type: types.GET_ALL_RELATED_DOCUMENTS_FOR_BODIES,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET',
				trackWithArea
			},
			entityUId: entityUId,
			documentCategoryName: categoryName
		}
	};
};

export function updateDocumentOnSignOffRemoval(documentId, approvalId, additionalParams) {
	return {
		type: types.UPDATE_DOCUMENT_ON_SIGNOFF_REMOVAL,
		documentId,
		approvalId,
		...additionalParams
	};
}

export function updateDocumentOnSignOffAddition(documentId, signOff, additionalParams) {
	return {
		type: types.UPDATE_DOCUMENT_ON_ADDING_SIGNOFF,
		documentId,
		signOff,
		...additionalParams
	};
}

function getDocumentsUrl(engagementId, queryStringParameters) {
	const searchString = !_.isEmpty(queryStringParameters) ? `?${queryString.stringify(queryStringParameters)}` : '';

	const url = `${Env.getBaseURL(serviceURL, engagementId)}Documents${searchString}`;

	return url;
}

export const addUploadingDocument = (newDoc) => {
	return {
		type: types.ADD_UPLOADING_DOCUMENT,
		meta: {
			newDoc: newDoc
		}
	};
};

export const createALRAPackage = (engagementId, instructionId, payload) => {
	const url = groupInstructinALRAPackageUrl(engagementId, instructionId);

	return {
		type: types.POST_ALRA_PACKAGE,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		}
	};
};

export const getRelatedDocument = (
	engagementId,
	documentId,
	bodyId,
	filteredEntityType = 'document',
	documentCategoryName = 'canvasFormBodyEvidence',
	includeApprovals = true,
	includeReviewNotes = true,
	includeRelatedTasks = true,
	includeRelatedEntities = true
) => {
	const query = {
		filteredEntityType,
		filteredEntityIdGuid: documentId,
		filteredEntityIdInt: bodyId,
		documentCategoryName,
		includeApprovals,
		includeReviewNotes,
		includeRelatedTasks,
		includeRelatedEntities,
		page: 1,
		pageSize: 1
	};

	const url = getDocumentsUrl(engagementId, query);

	return {
		type: types.GET_RELATED_DOCUMENT_FOR_BODY,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			},
			entityUId: bodyId,
			documentId
		}
	};
};

export const resetBodyRelatedDocuments = (bodyId) => {
	return {
		type: types.RESET_BODY_RELATED_DOCUMENTS,
		bodyId: bodyId
	};
};

export function daasCheckInCheckOutDocument(engagementId, entityUId, documentId, parentName, actionType) {
	let url = Env.getDocServiceUrl(`documents.json/${documentId}/${actionType}`);
	return {
		type: types.CHECK_IN_CHECK_OUT_DOCUMENT,
		entityUId: entityUId,
		documentId: documentId,
		parentName: parentName,
		meta: {
			api: {
				url: url,
				method: 'POST',
				headers: {
					engagementid: engagementId
				}
			}
		}
	};
}
